import { useState } from "react";

export function useTokenDistribution() {
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());

  const toggleRowExpansion = (hashKeyId: string) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      if (next.has(hashKeyId)) {
        next.delete(hashKeyId);
      } else {
        next.add(hashKeyId);
      }
      return next;
    });
  };

  return { expandedRows, toggleRowExpansion };
}
